import React, { useState, useEffect } from "react";
import "./assets/css/style.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-activity/dist/library.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Sentry } from "react-activity";
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import Layout from "./Layout";
import Dashboard from "./screens/Dashboard";
import Users from "./screens/Users";
import Adduser from "./screens/Users/Adduser";
import Edituser from "./screens/Users/Edituser";
import Viewuser from "./screens/Users/Viewuser";
import ProfileSettings from "./screens/ProfileSettings";
import Pages from "./screens/Pages";
import Posts from "./screens/posts";
import Viewpost from "./screens/posts/view-post";
import Editpost from "./screens/posts/edit-post";
import AdsPage from "./screens/ads";
import ViewAds from "./screens/ads/view-ads";
import InterestsPage from "./screens/interests";
import ContactsPage from "./screens/contact";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OtpScreen from "./auth/OtpScreen";
import FlagsReports from "./screens/flagsReports";
import AllComments from "./screens/posts/view-post/all-comments";
function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
     <ToastContainer />

      {loading ? (
        <div className="loaderdiv">
          <Sentry color="#2B5AAC" size={40} speed={1} animating={true} />
        </div>
      ) : (
        <Router basename={process.env.REACT_APP_BASENAME}>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/otp" element={<OtpScreen />} />
            <Route
              path="/dashboard"
              element={
                <Layout title={"Dashboard"}>
                  <Dashboard />
                </Layout>
              }
            />
            <Route
              path="/users"
              element={
                <Layout title={"Users"}>
                  <Users />
                </Layout>
              }
            />
            <Route
              path="/users/add-user"
              element={
                <Layout title={"Add User"}>
                  <Adduser />
                </Layout>
              }
            />
            <Route
              path="/users/edit-user"
              element={
                <Layout title={"Edit User"}>
                  <Edituser />
                </Layout>
              }
            />
            <Route
              path="/users/view-user"
              element={
                <Layout title={"View User"}>
                  <Viewuser />
                </Layout>
              }
            />
            <Route
              path="/posts"
              element={
                <Layout title={"Posts"}>
                  <Posts />
                </Layout>
              }
            />
            <Route
              path="/posts/view-post"
              element={
                <Layout title={"View Post"}>
                  <Viewpost />
                </Layout>
              }
            />

            <Route
              path="/posts/edit-post"
              element={
                <Layout title={"Edit Post"}>
                  <Editpost />
                </Layout>
              }
            />
            <Route
              path="/ads"
              element={
                <Layout title={"Ads"}>
                  <AdsPage />
                </Layout>
              }
            />
            <Route
              path="/ads/view-ads"
              element={
                <Layout title={"View Ads"}>
                  <ViewAds />
                </Layout>
              }
            />
            <Route
              path="/interests"
              element={
                <Layout title={"Interests"}>
                  <InterestsPage />
                </Layout>
              }
            />
            <Route
              path="/ads"
              element={
                <Layout title={"Ads"}>
                  <AdsPage />
                </Layout>
              }
            />
            <Route
              path="/contacts"
              element={
                <Layout title={"Contacts"}>
                  <ContactsPage />
                </Layout>
              }
            />
            <Route
              path="/pages"
              element={
                <Layout title={"Pages"}>
                  <Pages />
                </Layout>
              }
            />
            <Route
              path="/profile-settings"
              element={
                <Layout title={"Profile Settings"}>
                  <ProfileSettings />
                </Layout>
              }
            />
             <Route
              path="/flags-reports"
              element={
                <Layout title={"Flags Reports"}>
                  <FlagsReports />
                </Layout>
              }
            />
             <Route
              path="/posts/view-post/all-comments"
              element={
                <Layout title={"All Comments"}>
                  <AllComments />
                </Layout>
              }
            />
          </Routes>
        </Router>
      )}
    </>
  );
}

export default App;
